import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UseCollectionResult } from '@hooks/dashboard/useCollection'
import { HYGIENE_PLACEHOLDER } from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { FinanceMetricTileItem } from '@components/pages/Dashboard/Finance/FinanceMetricTiles.component'
import { dashboardFinanceMetricFooter } from '@components/pages/Dashboard/Finance/SectionCards/shared/dashboardFinanceMetricFooter'

type NetCollectionCardProps = {
  titleHref: string
  collection: UseCollectionResult
}

export function NetCollectionCard({
  titleHref,
  collection,
}: NetCollectionCardProps): React.ReactElement {
  const {
    loading,
    hasPayload,
    hasNetData,
    summary,
    netStr,
    collGoalLabel: goalLabel,
  } = collection
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasNetData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Collection"
      titleHref={titleHref}
      className="dashboard-finance-metric-card"
      loading={pending}
      skeleton={{ metrics: 1, block: 'none' }}
      isEmpty={isEmpty}
    >
      <FinanceMetricTileItem
        leftLabel="Net collection"
        value={loading ? HYGIENE_PLACEHOLDER : netStr}
        rightLabel={goalLabel}
        footer={
          summary
            ? dashboardFinanceMetricFooter(summary.netCollection, {
                isCurrency: true,
              })
            : undefined
        }
      />
    </DashboardSectionCard>
  )
}
